/*
 * A helper which allows to emulate a long running task.
 * Usage: await $sleep(5000)
 * */
export default function(ctx, inject) {
  const sleep = async (timeout) => {
    const task = new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve('Promise A win!')
      }, timeout)
    })
    await task
  }
  ctx.$sleep = sleep
  inject('sleep', sleep)
}
